// Reference: https://vuejs.org/v2/guide/components-registration.html#Automatic-Global-Registration-of-Base-Components

const requireComponent = require.context(
    // The relative path of the root folder.
    './../../..',
    // Look in subfolders.
    true,
    // Only include .vue.js files.
    /[\w-]+\.vue.js$/
);

const components = {};

requireComponent.keys().forEach(fileName => {
    // Get component config.
    const componentConfig = requireComponent(fileName);

    // Get pascal case name of component.
    const componentName = fileName.substr(fileName.lastIndexOf('/') + 1, fileName.length - fileName.lastIndexOf('/') - 8)
        .split('-').map(part => part.charAt(0).toUpperCase() + part.slice(1).toLowerCase()).join('');

    // Look for the component options on `.default`, which will exist if the component was exported with `export default` otherwise fall back to module's root.
    components[componentName] = componentConfig.default || componentConfig;
});

export default components;